// extracted by mini-css-extract-plugin
export var scrollArea = "_qw-0";